// Public-facing Terms of Service route.
//
// Canonical version is now maintained on the marketing site at
// https://tournyflex.com/terms — same pattern as PrivacyPage. Legal
// docs live together on the marketing domain so the web chat owns
// all legal maintenance (Terms + Privacy + future Cookie Policy),
// and both /terms and /privacy behave consistently regardless of
// which domain the user hit.
//
// This app-side route stays in place so links inside the app using
// href="/terms" (signup form, login page, PrivacyPage footer) don't
// fall through to the login OTP gate — that would break Twilio A2P
// 10DLC campaign review, which hits /terms anonymously.
//
// A hard redirect keeps the single source of truth on the marketing
// site and avoids having to embed / mirror the ToS in this repo.
// Uses location.replace so the app URL doesn't clutter the user's
// back stack.
//
// See docs/legal/terms-of-service.md for an archival snapshot of the
// last version that shipped from this repo (pre-web-repo migration).

import { useEffect } from 'react'

const CANONICAL = 'https://tournyflex.com/terms'

export default function TermsPage() {
  useEffect(() => {
    window.location.replace(CANONICAL)
  }, [])
  return (
    <div style={styles.page}>
      <p style={styles.para}>
        Redirecting to the TournyFlex Terms of Service…
      </p>
      <p style={styles.para}>
        If you are not redirected automatically, please visit{' '}
        <a href={CANONICAL} style={styles.link}>
          {CANONICAL}
        </a>
        .
      </p>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0B1426',
    color: '#F5F1E8',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    textAlign: 'center',
  },
  para: { margin: '8px 0', fontSize: 15, lineHeight: 1.6 },
  link: { color: '#D4B97A', textDecoration: 'underline' },
}
